import { Table, Button, Image, Tag, Modal } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

import { useEditModal } from './carCatalogsEditModal';
import { useCarMentenanceContext } from './carMaintenanceProvider';

export default function CarCatalogs() {
  const { showModal: showEditModal } = useEditModal();
  const {
    carCatalogs,
    deleteCarCatalog,
    isLoading: loading,
  } = useCarMentenanceContext();

  const columns = [
    {
      title: '編輯',
      dataIndex: 'edit',
      render: (_, record) => {
        return (
          <div>
            <Button
              type="primary"
              icon={<EditOutlined />}
              onClick={() => showEditModal(record)}
            />
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              className="button--delete"
              style={{ marginLeft: '5px' }}
              onClick={() => {
                Modal.confirm({
                  title: '刪除車款',
                  content: <p>你確定要刪除 {record.name} 這個車款嗎？</p>,
                  okText: '確定',
                  cancelText: '取消',
                  onOk: async () => await deleteCarCatalog(record.id),
                });
              }}
            />
          </div>
        );
      },
    },
    {
      title: '照片',
      dataIndex: 'img_path',
      render: (text) => {
        return <Image src={text} width={100} />;
      },
    },
    {
      title: '車型',
      dataIndex: 'car_type',
    },
    {
      title: '車款名稱',
      dataIndex: 'name',
    },
    {
      title: '高度',
      dataIndex: 'height',
    },
    {
      title: '寬度',
      dataIndex: 'width',
    },
    {
      title: '長度',
      dataIndex: 'length',
    },
    {
      title: '價格起',
      dataIndex: 'price',
    },
    {
      title: '價格止',
      dataIndex: 'price_until',
    },
    {
      title: '展示間網址',
      dataIndex: 'show_room_url',
    },
    {
      title: '啟用狀態',
      dataIndex: 'is_cancel',
      render: (status) => {
        return status ? (
          <Tag color="default">停用中</Tag>
        ) : (
          <Tag color="green">啟用中</Tag>
        );
      },
    },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={carCatalogs}
        loading={loading}
        pagination={false}
        scroll={{ x: 'max-content' }}
        rowKey="id"
      />
    </div>
  );
}
